module.exports = __webpack_public_path__ + "img/SexAppeal.6f6cf9a1.png";